(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredea3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredea3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5IiZx", function(module, exports) {
/*! js-cookie v3.0.8 | MIT */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});

});


var $5IiZx = parcelRequire("5IiZx");
$(document).ready(function() {
    var webSocket = new WebSocket("ws://localhost:54201/ws");
    webSocket.onopen = function(event) {
        /* Appena il client si connette, richiede a Nemesys lo stato corrente */ var req = {
            request: "currentstatus"
        };
        this.send(JSON.stringify(req));
    };
    webSocket.onmessage = function(event) {
        var msg = JSON.parse(event.data);
        this.readMessage(msg);
    };
    webSocket.onclose = function(event) {
        /**
         se la chiusura è stata causata da qualche errore
         */ if (event.code !== 1000) $9b160b73f6c62595$var$displayError(event.code);
    };
    webSocket.readMessage = function(msg) {
        switch(msg.type){
            case "sys_resource":
                $9b160b73f6c62595$var$sysResource("#" + msg.content.resource, msg.content.state, msg.content.info);
                break;
            case "wait":
                $9b160b73f6c62595$var$displayWaitView(msg.serial, msg.content.message, msg.content.seconds);
                break;
            case "end":
                $9b160b73f6c62595$var$displayEndView();
                break;
            case "notification":
                $9b160b73f6c62595$var$displayNotification(msg.content.error_code, msg.content.message);
                break;
            case "error":
                $9b160b73f6c62595$var$displayError(msg.content);
                break;
            case "measure":
                $9b160b73f6c62595$var$displayMeasureView(msg.content.test_type, msg.content.bw);
                break;
            case "tachometer":
                $9b160b73f6c62595$var$updateTachometer(msg.content.value);
                break;
            case "profilation":
                $9b160b73f6c62595$var$profilation(msg.content.done);
                break;
            case "result":
                $9b160b73f6c62595$var$displayResult(msg.content.test_type, msg.content.result, msg.content.error);
                break;
            case "test":
                $9b160b73f6c62595$var$displayTestN(msg.content.n_test, msg.content.n_tot, msg.content.retry);
                break;
            default:
                console.log("Wrong message");
        }
    };
    $(".wait-view").hide();
});
function $9b160b73f6c62595$var$displayStopRequest() {
    $("title").text("Nemesys - Interruzione");
    $("#hdr").text("Richiesta di interruzione inoltrata a Nemesys");
    $("#par").text("La richiesta di interruzione \xe8 stata inoltrata. L'operazione potrebbe richiedere qualche minuto.");
    $(".wait-view").hide();
    $("#tachometer").hide();
}
function $9b160b73f6c62595$var$displayNotification(error_code, message) {
    d = new Date();
    n = Math.ceil(Math.random() * 100000);
    var collapse = "collapse" + n;
    var heading = "heading" + n;
    var $accordion = $("#accordion");
    $accordion.prepend('<div class="panel panel-default"><div class="panel-heading" role="tab" id="' + heading + '">' + '<h5 class="panel-title">' + '<a class="text-danger" data-bs-toggle="collapse" data-parent="#accordion" ' + 'href="#' + collapse + '" aria-expanded="false" aria-controls="' + collapse + '">' + d.getHours() + ":" + d.getMinutes() + " - " + message + "</a></h5></div>" + '<div id="' + collapse + '" class="panel-collapse collapse" role="tabpanel" aria-labelledby="' + heading + '">' + '<a href="#' + error_code + '">Codice errore: ' + error_code + "</a></div></div>");
    var listelements = $accordion.children();
    if (listelements.length > 10) listelements[listelements.length - 1].remove();
}
function $9b160b73f6c62595$var$profilation(done) {
    var $sysresource = $(".sysresource");
    $sysresource.removeClass("card-danger");
    $sysresource.removeClass("card-primary");
    if (done) $("#profilAlert").modal("hide");
    else $("#profilAlert").modal("show");
}
function $9b160b73f6c62595$var$displayResult(test_type, result, error) {
    $("#tachometer")[0].set(0);
    var $par = $("#par");
    if (error) $par.text("Test di " + test_type + " fallito: " + error + ". Nuovo tentativo fra pochi secondi...");
    else {
        var r = "Valore misurato: " + result / 1000.0;
        switch(test_type){
            case "ping":
                $par.text(r + " ms");
                break;
            default:
                $par.text(r + " Mbit/s");
                break;
        }
    }
}
function $9b160b73f6c62595$var$updateTachometer(value) {
    $("#tachometer")[0].set(value);
}
function $9b160b73f6c62595$var$displayTestN(n_test, n_tot, retry) {
    if (retry) $("#par").text("Misura ripresa dopo l'interruzione. Test " + n_test + " di " + n_tot + ".");
    else $("#par").text("Test " + n_test + " di " + n_tot + ".");
}
function $9b160b73f6c62595$var$displayMeasureView(test_type, bw) {
    $("title").text("Nemesys - Misurazione in corso");
    $("#par").text("");
    $("#pdf-button").hide();
    $(".wait-view").hide();
    var $tachometer = $("#tachometer");
    var $hdr = $("#hdr");
    $tachometer.empty();
    $tachometer.show();
    var settings = {
        class: "arc-gauge",
        width: 300,
        height: 300,
        startAngle: -120,
        endAngle: 60,
        thickness: 20,
        maxValue: bw || 100,
        onchange: function(value) {
            $(".arc-gauge-text .value").text(value.toFixed(1));
        }
    };
    switch(test_type){
        case "upload":
            $hdr.text("Test di upload in corso...");
            $tachometer.append('<div class="arc-gauge-text"><span class="value">0</span><span class="small"> Mbit/s</span></div>');
            settings.colors = "#4eb14e";
            $tachometer.arcGauge(settings);
            break;
        case "download":
            $hdr.text("Test di download in corso...");
            $tachometer.append('<div class="arc-gauge-text"><span class="value">0</span><span class="small"> Mbit/s</span></div>');
            settings.colors = "#2b8bd4";
            $tachometer.arcGauge(settings);
            break;
        case "ping":
            $hdr.text("Test di latenza in corso...");
            $tachometer.append('<div class="arc-gauge-text"><span class="value">0</span><span class="small"> ms</span></div>');
            settings.colors = "#eb9114";
            $tachometer.arcGauge(settings);
            break;
        default:
            $hdr.text("");
    }
}
function $9b160b73f6c62595$var$displayEndView() {
    $("title").text("Nemesys - Misurazione terminata");
    $("#hdr").text("Nemesys ha terminato le sue misurazioni.");
    $("#par").text("Le misurazioni sono state completate. Accedi all'area personale per scaricare il certificato.");
    $("#pdf-button").show();
    $(".wait-view").hide();
    $("#tachometer").hide();
}
function $9b160b73f6c62595$var$displayWaitView(serial, msg, seconds) {
    $("#pdf-button").hide();
    $("#tachometer").hide();
    $(".wait-view").show();
    $("title").text("Nemesys - Network Measurement System");
    $("#hdr").text("Nemesys \xe8 in attesa di effettuare una nuova misura.");
    /*
     1) post al backend;
     2) risultato: {up/down/ping:[{time:Date, "value":number}]}
     3) formato del grafico (per ogni grafico):
     [{
     hour:"HH:00 - "(HH+1%24):00",
     val0: prima misura della fascia
     ...
     valN-1: Nesima
     }]
     */ var ajax_query_data = {
        serial: serial,
        request: "measures_detail"
    };
    const csrftoken = (0, (/*@__PURE__*/$parcel$interopDefault($5IiZx))).get("csrftoken");
    var ajax_post_settings = {
        async: true,
        url: "/get_measures_detail/",
        method: "POST",
        headers: {
            "X-CSRFToken": csrftoken,
            "content-type": "application/json",
            "cache-control": "no-cache"
        }
    };
    var measures_ajax_settings = $.extend({
        data: JSON.stringify(ajax_query_data),
        datatype: "json"
    }, ajax_post_settings);
    $.ajax(measures_ajax_settings).done(function(response, textStatus, jqXHR) {
        if (textStatus === "success") {
            // var response = JSON.parse(res)[0];
            var n_tot = response.ntot;
            $("#par").text("Sono state effettuate " + response.down.length + " misurazioni su " + n_tot + ". " + msg);
            var datapoints_up = $9b160b73f6c62595$var$list2datapoints(response.up, n_tot);
            var datapoints_down = $9b160b73f6c62595$var$list2datapoints(response.down, n_tot);
            var datapoints_ping = $9b160b73f6c62595$var$list2datapoints(response.ping, n_tot);
            var y_k = Object.keys(datapoints_up[0]).filter(function(element) {
                return element.startsWith("val");
            });
            var lbs = [];
            for(var i = 1; i <= y_k.length; i++)lbs.push(i + "\xb0 test");
            var settings = {
                xkey: "hour",
                ykeys: y_k,
                labels: lbs,
                barGap: 1,
                barSizeRatio: 0.97,
                hideHover: true,
                behaveLikeLine: true,
                parseTime: false,
                resize: true
            };
            var $up = $("#up-container");
            var $down = $("#down-container");
            var $ping = $("#ping-container");
            $up.empty();
            $up.append('<div id="up-bar"></div>');
            var settings_d = {
                element: "up-bar",
                data: datapoints_up,
                yLabelFormat: function(y) {
                    return y <= 0 ? "-" : (y / 1000).toFixed(2) + " Mbit/s";
                },
                barColors: [
                    "#4eb14e"
                ]
            };
            $.extend(settings_d, settings);
            Morris.Bar(settings_d);
            $down.empty();
            $down.append('<div id="down-bar"></div>');
            var settings_u = {
                element: "down-bar",
                data: datapoints_down,
                yLabelFormat: function(y) {
                    return y <= 0 ? "-" : (y / 1000).toFixed(2) + " Mbit/s";
                },
                barColors: [
                    "#2b8bd4"
                ]
            };
            $.extend(settings_u, settings);
            Morris.Bar(settings_u);
            $ping.empty();
            $ping.append('<div id="ping-bar"></div>');
            var settings_p = {
                element: "ping-bar",
                data: datapoints_ping,
                yLabelFormat: function(y) {
                    return y <= 0 ? "-" : y.toFixed(2) + " ms";
                },
                barColors: [
                    "#eb9114"
                ]
            };
            $.extend(settings_p, settings);
            Morris.Bar(settings_p);
        }
    });
}
function $9b160b73f6c62595$var$list2datapoints(meas_list, meas_tot) {
    var valN = meas_tot / 24; // misure per fascia oraria
    var datapoints = [];
    for(var i = 0; i < 24; i++){
        //costruisce l'object che rappresenta una fascia oraria
        var point = {};
        point.hour = i + ":00 - " + (i + 1) % 24 + ":00";
        //filtro per ora corrente e ordino
        var curr_hour = meas_list.filter(function(element) {
            var d1 = new Date(element.time);
            return d1.getHours() === i;
        }).sort(function(a, b) {
            return new Date(a.time) - new Date(b.time);
        });
        for(var j = 0; j < valN; j++){
            var k = "val" + j;
            if (curr_hour[j]) point[k] = curr_hour[j].value;
            else point[k] = 0;
        }
        datapoints.push(point);
    }
    return datapoints;
}
function $9b160b73f6c62595$var$sysResource(resource, state, info) {
    switch(state){
        case "error":
            $(resource).removeClass("card-primary");
            $(resource).addClass("card-danger");
            break;
        case "ok":
            $(resource).removeClass("card-danger");
            $(resource).addClass("card-primary");
            break;
        default:
            $(resource).removeClass("card-danger");
            $(resource).removeClass("card-primary");
    }
}
function $9b160b73f6c62595$var$displayError(errorMsg) {
    $("title").text("Misurainternet - Ne.Me.Sys");
    $("#hdr").html("Questa \xe8 l'interfaccia grafica di Ne.Me.Sys. Qui verr\xe0 visualizzato l'andamento delle tue misure quando installerai Ne.Me.Sys.<br/><br/>Ne.Me.Sys. attualmente non risulta presente sul tuo dispositivo");
    var $par = $("#par");
    switch(errorMsg){
        case 1006:
            $par.empty();
            $par.append('<strong>I nostri sistemi non riescono a contattare il tuo Ne.Me.Sys.</strong><br><br>Assicurati di:<ul><li>accedere alla tua <a href="/login/">area riservata</a> per poter <a href="/download/nemesys/">scaricare il software Ne.Me.Sys</a>.</li><li>di aver quindi <strong>scaricato</strong> ed <strong>installato Ne.Me.Sys.</strong> sul tuo PC.</li></ul><br><strong>Una volta completata l\u2019installazione, potrai vedere l\u2019avanzamento delle tue misure su questa pagina.</strong><br><br>Se invece hai gi\xe0 installato Ne.Me.Sys. e visualizzi questa schermata, allora prova a riavviare il computer.<br><br>Qualora continuassi a visualizzare questo messaggio, l\u2019installazione o l\u2019avvio di Ne.Me.Sys. potrebbero non essere andati a buon fine o potrebbe non essersi avviato il servizio. Contatta il nostro <a href="/supporto/">helpdesk.</a> per farti guidare nella risoluzione della tua problematica.<br><br>Se invece vuoi saperne di pi\xf9 su Ne.Me.Sys. vai a questa <a href="/info_nemesys/">pagina</a>.');
            break;
        default:
            $par.text(errorMsg);
    }
    $(".wait-view").hide();
    $("#profilAlert").modal("hide");
    $("#tachometer").hide();
    $("#pdf-button").hide();
}

})();
//# sourceMappingURL=gui.js.map
